<div
  (click)="onClick()"
  (keydown.enter)="onClick()"
  [class.shadow]="showShadow"
  class="icon-tile"
  tabindex="0"
>
  <div class="icon-tile__icon">
    <ui-icon [icon]="matIcon"></ui-icon>
  </div>
  <div class="icon-tile__text">
    <div>{{ title }}</div>
    @if (isExternal) {
      <ui-icon icon="open_in_new"></ui-icon>
    }
  </div>
</div>
